export default "__VITE_ASSET__Dd9B4tQA__"